export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8146.eaf4e4f2.jpg";